<script setup>
import { ref, onBeforeMount } from 'vue'
import ButtonAll from '../Components/UI/Button/ButtonAll.vue'
import ContractSignatureAlert from '../Components/Contract/ContractSignatureAlert.vue'
import { ContractSignatureError } from '../../../Errors/ContractSignatureError'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const urlParams = new URLSearchParams(window.location.search)
const contractId = urlParams.get('contractId')
const signError = new ContractSignatureError(urlParams.get('error') || t('esign.error'), 'esign.error')

onBeforeMount(() => {
  if (contractId === '' || !contractId) {
    window.location = '/'
  }
})
</script>

<template>
  <main class="main-container">
    <div class="row">
      <div class="col-md-12 text-center">
        <div id="image_logo" title="<?php echo COMPANY; ?>"></div>
      </div>
      <div class="col-md-12">
        <h1 class="text-center font-weight-bold">
          {{ $t('esign.signatureTitle') }}
        </h1>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-6">
        <div class="mx-2 mt-5">
          <ContractSignatureAlert :error="signError" />

          <ButtonAll
            type="validation"
            width="full"
            label="contract.information.button.goToContract"
            :href="`contrats/contract.php?i=${contractId}`"
          />
        </div>
      </div>
    </div>
  </main>
</template>
